export default __webpack_public_path__ + "static/media/header-logo.095e5df9.svg";